const SIM_STATES = {
  ACTIVATED: {value: 'ACTIVATED', label: 'Activée'},
  ACTIVATING: {value: 'ACTIVATING', label: 'En cours d\'activation'},
  DOWNGRADING: {value: 'DOWNGRADING', label: 'Changement vers forfait inférieur'},
  NEED_ACTIVATION: {value: 'NEED_ACTIVATION', label: 'Demande d\'activation'},
  NEED_DOWNGRADE: {value: 'NEED_DOWNGRADE', label: 'Demande de forfait supérieur'},
  NEED_TERMINATION: {value: 'NEED_TERMINATION', label: 'Demande de désactivation'},
  NEED_UPGRADE: {value: 'NEED_UPGRADE', label: 'Demande de forfait inférieur'},
  NOT_ACTIVATED: {value: 'NOT_ACTIVATED', label: 'Non activée'},
  SUSPENDED: {value: 'SUSPENDED', label: 'Suspendue'},
  TERMINATED: {value: 'TERMINATED', label: 'Désactivée'},
  TERMINATING: {value: 'TERMINATING', label: 'En cours de désactivation'},
  UNKNOWN: {value: 'UNKNOWN', label: 'Inconnu'},
  UPGRADING: {value: 'UPGRADING', label: 'Changement vers forfait supérieur'},
};

const isTransatel = sim => sim?.operator?.toUpperCase()?.startsWith('TRANSATEL');

const getSimStateClass = (simState) => {
  switch (simState) {
    case SIM_STATES.NEED_ACTIVATION.value:
    case SIM_STATES.ACTIVATING.value:
    case SIM_STATES.DOWNGRADING.value:
    case SIM_STATES.NEED_DOWNGRADE.value:
    case SIM_STATES.NEED_UPGRADE.value:
    case SIM_STATES.UPGRADING.value:
      return 'warning';
    case SIM_STATES.ACTIVATED.value:
      return 'success';
    case SIM_STATES.NEED_TERMINATION.value:
    case SIM_STATES.TERMINATING.value:
    case SIM_STATES.TERMINATED.value:
      return 'danger';
    case SIM_STATES.NOT_ACTIVATED.value:
    default:
      return 'default';
  }
};

const getSimStateIcon = (simState) => {
  switch (simState) {
    case SIM_STATES.NOT_ACTIVATED.value:
      return 'times-circle';
    case SIM_STATES.ACTIVATED.value:
      return 'check-circle';
    case SIM_STATES.NEED_ACTIVATION.value:
    case SIM_STATES.NEED_TERMINATION.value:
      return 'info-circle';
    case SIM_STATES.ACTIVATING.value:
    case SIM_STATES.DOWNGRADING.value:
    case SIM_STATES.TERMINATING.value:
    case SIM_STATES.UPGRADING.value:
      return 'spinner';
    case SIM_STATES.TERMINATED.value:
      return 'stop-circle';
    case SIM_STATES.SUSPENDED.value:
      return 'pause-circle';
    default:
      return 'question-circle';
  }

};

const SIM_OPERATORS = {
  LPM: {
    name: 'LPM',
    iccid_validation: [
      {length: 20, prefix: '893310', label: 'LPM (SFR)'},
      {length: 19, prefix: '893320', label: 'LPM (Bytel)'},
    ],
  },
  TRANSATEL: {
    name: 'TRANSATEL',
    iccid_validation: [
      {length: 20, prefix: '893301', label: 'Transatel'},
    ],
  },
  TRANSATEL_FULL: {
    name: 'TRANSATEL_FULL',
    iccid_validation: [
      {length: 19, prefix: '893322', label: 'Transatel full'},
    ],
  },
  TRANSATEL_MULTI: {
    name: 'TRANSATEL_MULTI',
    iccid_validation: [
      {length: 19, prefix: '898824', label: 'Transatel multi'},
    ],
  },
};

const SIM_PLANS = {
  CLASSIC: {
    label: 'Sim',
    value: 'Classic',
  },
  SIM_PLUS: {
    label: 'Sim Plus',
    value: 'SimPlus',
  },
};

export const getSimPlanLabel = plan => Object.values(SIM_PLANS).find(
  (p) => p.value === plan,
)?.label || '';

export const getSimPlanFromState = currentState => {
  if ([SIM_STATES.NEED_DOWNGRADE.value, SIM_STATES.NEED_UPGRADE.value].includes(currentState?.state)) {
    return `${getSimPlanLabel(currentState?.simState?.from)} => ${getSimPlanLabel(currentState?.simState?.to)}`;
  } else {
    return getSimPlanLabel(currentState?.simState?.plan);
  }
};

export {
  SIM_OPERATORS,
  SIM_PLANS,
  SIM_STATES,
  getSimStateClass,
  getSimStateIcon,
  isTransatel,
};